"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Nextstepbusinessmatter() {
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.2
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const {
    ref: captionRef,
    isVisible: captionRefVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.3
  });
  return <section data-section-id="4535" id="nextstepbusinessmatter" className="bg-background text-foreground relative w-full overflow-hidden py-24 md:py-32">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <div ref={labelRef} className={`inline-block mb-4 text-xs font-semibold uppercase tracking-widest text-primary transition-all duration-700 ${labelVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          Confidential Legal Counsel
        </div>
        
        <h2 ref={headingRef} className={`font-serif text-3xl md:text-4xl lg:text-5xl font-bold mb-6 tracking-normal transition-all duration-700 delay-100 ${headingVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          Discuss Your Business Matter With Us
        </h2>
        
        <p ref={bodyRef} className={`text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed transition-all duration-700 delay-200 ${bodyVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          Schedule a consultation to discuss your corporate governance, transactions, or selective litigation needs with an experienced South Florida attorney.
        </p>
        
        <div ref={ctaRef} className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${ctaVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-md shadow-md h-11 px-8">
            <Link to="/ContactUsPage">
              Request a Consultation <ArrowRight className="size-4 ml-2" />
            </Link>
          </Button>
          <Button asChild variant="outline" className="rounded-md h-11 px-8 border-border">
            <Link to="/BusinessCorporateServicesPage">
              View Practice Areas
            </Link>
          </Button>
        </div>

        <p ref={captionRef} className={`text-xs text-muted-foreground/80 mt-8 transition-all duration-700 delay-400 ${captionRefVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          Initial consultations are strictly confidential and do not establish an attorney-client relationship.
        </p>
      </div>
    </section>;
}